import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import SoldOption from './ArchivingOption/SoldOption';

const StatusOption = ({ itemFormData, setItemFormData, statusData, salesChannelData, locationData }) => {
  const [tempStatusData, setTempStatusData] = useState([]);
  const [tempSalesChannelData, setTempSalesChannelData] = useState([]);
  const [tempLocationData, setTempLocationData] = useState([]);
  const [statusIndex, setStatusIndex] = useState(0);

  useEffect(() => {
    if (statusData && salesChannelData && locationData) {
      setTempStatusData(statusData);
      setTempSalesChannelData(salesChannelData);
      setTempLocationData(locationData);
    }
  }, [statusData, salesChannelData, locationData]);

  useEffect(() => {
    setStatusIndex(itemFormData.statuses.length - 1);
  }, [itemFormData.statuses]);

  const updateStatusAtIndex = (index, newStatus) => {
    setItemFormData(prevData => {
      const updatedStatuses = [...prevData.statuses];
      updatedStatuses[index] = { ...updatedStatuses[index], ...newStatus };
      return { ...prevData, statuses: updatedStatuses };
    });
  };

  const handleOptionChange = (e) => {
    const statusName = e.target.value;
    const selectedStatus = tempStatusData.find(status => status.name === statusName);
    const newStatus = statusName === 'exclusive'
      ? { status: selectedStatus, sales_channel: { id: 1, channel: "chelsea's treasure trove" } }
      : statusName !== 'exclusive' && statusName !== 'listed' && statusName !== 'sold'
      ? { status: selectedStatus, sales_channel: { id: 0, channel: '' } }
      : { status: selectedStatus };
    updateStatusAtIndex(statusIndex, newStatus);
  };

  const handleReviewDateChange = (e) => {
    updateStatusAtIndex(statusIndex, { review_date: e.target.value + "T00:00:00.000Z" });
  };

  const handleSalesChannelChange = (e) => {
    const channelName = e.target.value;
    const selectedChannel = tempSalesChannelData.find(channel => channel.channel === channelName);
    const newSalesChannel = selectedChannel
      ? selectedChannel
      : { id: 0, channel: channelName };
    updateStatusAtIndex(statusIndex, { sales_channel: newSalesChannel });
  };

  const handleLocationChange = (e) => {
    const locationName = e.target.value;
    const selectedLocation = tempLocationData.find(location => location.name === locationName);
    setItemFormData(prevData => ({
      ...prevData,
      location: selectedLocation ? selectedLocation : { id: 0, name: locationName }
    }));
  };

  return (
    <div>
      <br />
      <label htmlFor='selectedOption'>Status:</label>
      <select
        name='selectedOption'
        id='selectedOption'
        value={itemFormData.statuses[statusIndex].status.name}
        onChange={handleOptionChange}
      >
        {tempStatusData.map((status) => (
          <option key={status.id} value={status.name}>
            {status.name}
          </option>
        ))}
      </select>
      {(['listed', 'sold'].includes(itemFormData.statuses[statusIndex].status.name)) && (
        <div>
          <label>
            Sales Channel:
            <input
              type="text"
              name="sales_channel"
              value={itemFormData.statuses[statusIndex].sales_channel.channel || ''}
              onChange={handleSalesChannelChange}
              list="salesChannelOptions"
              placeholder="Enter channel name"
            />
            <datalist id="salesChannelOptions">
              {tempSalesChannelData.map((sales_channel) => (
                <option key={sales_channel.id} value={sales_channel.channel} />
              ))}
            </datalist>
          </label>
        </div>
      )}
      {itemFormData.statuses[statusIndex].status.name === 'sold' && (
        <SoldOption
          formData={itemFormData}
          setFormData={setItemFormData}
        />
      )}
      {(['exclusive', 'shelved', 'listed'].includes(itemFormData.statuses[statusIndex].status.name)) && (
        <div>
          <label htmlFor="reviewDate">Review Date:</label>
          <input
            type="date"
            name="review_date"
            id="review_date"
            value={itemFormData.statuses[statusIndex].review_date || ''}
            onChange={handleReviewDateChange}
          />
        </div>
      )}
      {(['exclusive', 'shelved', 'listed'].includes(itemFormData.statuses[statusIndex].status.name)) && (
        <div>
          <label>
            Storage Location:
            <input
              type="text"
              name="location"
              value={itemFormData.location.name || ''}
              onChange={handleLocationChange}
              list="locationOptions"
              placeholder="Enter location name"
            />
            <datalist id="locationOptions">
              {tempLocationData.map((location) => (
                <option key={location.id} value={location.name} />
              ))}
            </datalist>
          </label>
        </div>
      )}
    </div>
  );
};

StatusOption.propTypes = {
  itemFormData: PropTypes.object.isRequired,
  setItemFormData: PropTypes.func.isRequired,
  statusData: PropTypes.array,
  salesChannelData: PropTypes.array,
  locationData: PropTypes.array,
  itemId: PropTypes.number
};

export default StatusOption;
